import { Button, Container, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { Section } from '@/components/ui/core/Section/Section';
import { LibraryFilterDrawer } from '@/components/ui/features/library/LibraryFilter/layouts/LibraryFilterDrawer';
import { SearchInputFormCompatible } from '@/components/ui/shared/inputs/SearchInput/SearchInputFormCompatible';
import { DrawerState } from '@/enums/DrawerState';
import { useLibLynx } from '@/hooks/useLibLynx';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const LectureSearchInput: FC = () => {
  const { t } = useTranslation();
  const libLynx = useLibLynx();
  const { drawerState, change, query } = useQueryParams<{ drawerState: DrawerState; query: string }>({
    drawerState: StringParam,
    query: StringParam,
  });
  const { register, handleSubmit } = useForm();

  function handleOnClose() {
    change({ drawerState: DrawerState.CLOSED, query }, { method: 'replace', shallow: true, scroll: true });
  }

  function handleOnOpen() {
    change({ drawerState: DrawerState.OPEN, query }, { method: 'replace', shallow: true, scroll: true });
  }

  const isDrawerOpen = drawerState === DrawerState.OPEN;

  function onSubmit(props: { query: string }) {
    change({ drawerState, query: props.query }, { method: 'replace', shallow: true, scroll: true });
    libLynx.send('trackSearch');
  }

  return (
    <Section py={5} bgColor="violet.500" position="sticky" top="63px" zIndex="dropdown">
      <LibraryFilterDrawer isOpen={isDrawerOpen} onClose={handleOnClose} />
      <Container centerContent>
        <Flex as="form" onSubmit={handleSubmit(onSubmit)} flexDir={{ base: 'column-reverse', sm: 'row' }} w="full">
          <Button
            mt={{ base: 4, sm: 0 }}
            mr={{ base: 0, sm: 4 }}
            px={{ base: 10, md: 14, lg: 16 }}
            colorScheme="white"
            variant="solid"
            size="md"
            onClick={handleOnOpen}
            rightIcon={<FilterList />}
          >
            {t('library.filters')}
          </Button>
          <SearchInputFormCompatible
            w="full"
            bg="white"
            {...register('query')}
            color="gray.700"
            borderRadius="full"
            placeholder={t('library.search.placeholder')}
            defaultValue={query}
          />
        </Flex>
      </Container>
    </Section>
  );
};
